import { compact, get } from "lodash-es";

export const createArray = (cnt) => {
  return Array.from({ length: cnt }).map((_, i) => {
    return i + 1;
  });
};

export const createIdGenerate = () => {
  function* _createIdGenerate({ start = 0, step = 1 } = {}) {
    let id = start;
    while (true) {
      yield id;
      id += step;
    }
  }

  const idGenerate = _createIdGenerate();

  return {
    getNextId() {
      return idGenerate.next().value;
    }
  };
};

export const createDefaultPaginationInfo = ({ pageSize = 15 } = {}) => {
  return {
    pageNum: 1,
    pageSize
  };
};

export const createDefServerListDataRes = () => {
  return {
    data: {
      records: [],
      total: 0
    }
  };
};

export function paddingFraction(number, { padding = 2 } = {}) {
  return number.toString().replace(/([0-9]*)\.?([0-9]*)/, (...args) => {
    const [_, integerPart, fractionPart] = args;
    return integerPart + "." + fractionPart.padEnd(padding, "0");
  });
}

export const createDefServerListRes = ({ records = [], total = 0 } = {}) => {
  return {
    records,
    total
  };
};

export const distinct = (iter) => {
  return [...new Set(iter)];
};

export function createCachedCalc(calcFn, keyPath, { isChanged = (_newV, _oldV) => false } = {}) {
  const map = new Map();

  return function calcData(data) {
    function getKey() {
      return get(unref(data), unref(keyPath));
    }

    function createAndCacheComputed() {
      const res = computed(() => calcFn(unref(data)));

      map.set(key, res);

      return res;
    }

    const key = getKey();

    if (!map.has(key)) {
      return createAndCacheComputed();
    }

    const oldV = map.get(key);

    if (isChanged(unref(data), unref(oldV))) {
      return createAndCacheComputed();
    }

    return oldV;
  };
}

export const createEmptyRemark = () => ({ remark: "" });

export class TagStruct {
  constructor(label, value, type) {
    this.label = label;
    this.value = value;
    this.type = type;
  }

  static createPrimary(label, value) {
    return new TagStruct(label, value, "primary");
  }

  static createNA() {
    return new TagStruct("NA", "", "primary");
  }

  static createInfo(label, value) {
    return new TagStruct(label, value, "info");
  }
}

export function deepToRaw(value) {
  if (Array.isArray(value)) {
    return value.map((item) => deepToRaw(item));
  }

  if (value !== null && typeof value === "object") {
    const raw = isReactive(value) ? toRaw(value) : value;
    const result = {};
    for (const key in raw) {
      result[key] = deepToRaw(raw[key]);
    }
    return result;
  }

  return value;
}

export function alwaysTrue() {
  return true;
}

export function alwaysFalse() {
  return false;
}

export const getPropPathFactory = (propPrefixPath) => (propPath) => {
  return compact(Array.of(unref(propPrefixPath), propPath)).join(".");
};

/**
 *
 * @param {number|string} state
 * @param {number|string[]} expectedStates
 * @returns {*}
 */
export function isStateHas(state, expectedStates) {
  return expectedStates.some((expectedState) => String(expectedState) === String(state));
}

/**
 * @param {number|string} state
 * @param {number|string} expectedState
 * @returns {*}
 */
export function isStateEqual(state, expectedState) {
  return isStateHas(state, Array.of(expectedState));
}

/**
 *
 * @param {number|string} state
 * @param {number|string[]} expectedStates
 * @returns {*}
 */
export function isStateHasAll(state, expectedStates) {
  return expectedStates.every((expectedState) => String(expectedState) === String(state));
}
